import { useState } from 'react'
import { JSONFetcher, Modal, gaEvent } from 'shared'

export const SubscribeModal = (props) =>
  <Modal
    show={props.show}
    onHide={props.onHide}
    id='project-newsletter-subscription-modal'
    content={<SubscriptionForm {...props} onHide={props.onHide} />}
    header={I18n.t('projects.show.stats.subscribe_modal_headline')}
    headerSubline={I18n.t('projects.show.stats.subscribe_modal_subline')}
  />

const SubscriptionForm = (props) => {
  const [state, setState] = useState({
    email: '',
    projectNewsletter: true,
    platformNewsletter: true,
    submitted: false,
    error: false,
    showModal: false
  })

  const handleSubmit = (event) => {
    if (state.platformNewsletter)
      gaEvent('engagement', 'submit subscribe_platform_newsletter_form')
    if (state.projectNewsletter)
      gaEvent('engagement', 'submit subscribe_project_newsletter_form')
    event.preventDefault()
    JSONFetcher.post({
      url: props.url,
      body: {
        email: state.email,
        platform_newsletter: state.platformNewsletter,
        project_newsletter: state.projectNewsletter
      },
      success: (response) => {
        if (response.error) {
          setState({ ...state, error: response.error })
          gaEvent('error', 'field: newsletter_email', `error: ${response.error}`, null, true)
        } else {
          setState({ ...state, submitted: true })
        }
      }
    })
  }

  if (state.submitted) {
    return <div>
      <p>{I18n.t('projects.show.stats.subscribe_modal_thank_you')}</p>
      <button className='btn btn-primary btn-large' onClick={props.onHide}>
        {I18n.t('projects.show.stats.subscribe_modal_close_button')}
      </button>
    </div>
  }

  return <div>
    <form className='simple_form' onSubmit={handleSubmit}>
      <div className='form-group'>
        <label className='control-label' htmlFor='mailing_newsletter_opt_in_email'>
          <abbr title="required">*</abbr> E-Mail
        </label>
        <input
          className={`form-control ${state.error ? 'field-with-error' : ''}`}
          id='mailing_newsletter_opt_in_email'
          type='text'
          value={state.email}
          onChange={(event) => setState({ ...state, email: event.target.value })}
        />
        {state.error && <div className='help-inline'>{state.error}</div>}
      </div>

      <div className='form-group'>
        <div className='checkbox'>
          <label>
            <input
              type='checkbox'
              checked={state.projectNewsletter}
              onChange={(event) => setState({ ...state, projectNewsletter: event.target.checked })}
            /> <span dangerouslySetInnerHTML={{ __html: I18n.t('projects.show.stats.subscription_project_label', { project_name: props.project.title }) }} />
          </label>
        </div>
      </div>

      <div className='form-group'>
        <div className='checkbox'>
          <label>
            <input
              type='checkbox'
              checked={state.platformNewsletter}
              onChange={(event) => setState({ ...state, platformNewsletter: event.target.checked })}
            /> {I18n.t('projects.show.stats.subscription_platform_label')}
          </label>
        </div>
      </div>

      <div className='form-actions text-center'>
        <input type='submit' value={I18n.t('projects.show.stats.subscription_modal_button')} className='btn btn-primary btn-large' />
      </div>

      <div className='text-muted mt-4'
        dangerouslySetInnerHTML={{ __html: I18n.t('projects.show.stats.subscription_modal_disclaimer') }}
      />
    </form>
  </div>
}
